import { render } from "./number_step.vue?vue&type=template&id=3fff30e4"
import script from "./number_step.vue?vue&type=script&lang=js"
export * from "./number_step.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"app/javascript/submission_form/number_step.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3fff30e4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3fff30e4', __exports__)) {
    api.reload('3fff30e4', __exports__)
  }
  
  module.hot.accept("./number_step.vue?vue&type=template&id=3fff30e4", () => {
    api.rerender('3fff30e4', render)
  })

}


export default __exports__